import { apiClient } from './client';

export interface OrganizationScimGroupMapping {
  id: number;
  organization_id: number;
  merchant_display_name: string;
  loop_display_name: string;
  created_at: string | null;
  updated_at: string | null;
}

export interface OrganizationScimGroupMappingPayload {
  merchant_display_name: string;
  loop_display_name: string;
}

export function listOrganizations (params: {
  search?: string;
  type?: string | null;
  page?: number;
  per_page?: number;
} = {}) {
  return apiClient.get('/organizations', {
    params: {
      search: params.search || undefined,
      type: params.type || undefined,
      page: params.page,
      per_page: params.per_page,
    },
  });
}

export function getOrganization (organizationId: number | string) {
  return apiClient.get(`/organizations/${organizationId}`);
}

export function createOrganization (payload: { slug: string; type?: string | null }) {
  return apiClient.post('/organizations', payload);
}

export function updateOrganization (organizationId: number | string, payload: { auth_provider_organization_id: string | null }) {
  return apiClient.patch(`/organizations/${organizationId}`, payload);
}

export function getOrganizationShops (organizationId: number | string) {
  return apiClient.get(`/organizations/${organizationId}/shops`);
}

export function getRelationshipTypes () {
  return apiClient.get('/organizations/relationship-types');
}

export function getOrganizationTypes () {
  return apiClient.get('/organizations/types');
}

export function attachShop (organizationId: number | string, shopId: number | string, relationshipType?: string) {
  return apiClient.post(`/organizations/${organizationId}/attach`, {
    shop_id: shopId,
    relationship_type: relationshipType,
  });
}

export function detachShop (organizationId: number | string, shopId: number | string, relationshipType?: string) {
  return apiClient.post(`/organizations/${organizationId}/detach`, {
    shop_id: shopId,
    relationship_type: relationshipType,
  });
}

export function getScimConfig (organizationId: number | string) {
  return apiClient.get(`/organizations/${organizationId}/scim-config`);
}

export function updateScimConfig (organizationId: number | string, payload: { idp_provider: string; is_derivation_enabled: boolean }) {
  return apiClient.put(`/organizations/${organizationId}/scim-config`, payload);
}

export function listScimGroupMappings (organizationId: number | string) {
  return apiClient.get<OrganizationScimGroupMapping[]>(`/organizations/${organizationId}/scim-group-mappings`);
}

export function createScimGroupMapping (
  organizationId: number | string,
  payload: OrganizationScimGroupMappingPayload,
) {
  return apiClient.post<{
    message: string;
    data: OrganizationScimGroupMapping;
  }>(`/organizations/${organizationId}/scim-group-mappings`, payload);
}

export function updateScimGroupMapping (
  organizationId: number | string,
  mappingId: number | string,
  payload: OrganizationScimGroupMappingPayload,
) {
  return apiClient.put<{
    message: string;
    data: OrganizationScimGroupMapping;
  }>(`/organizations/${organizationId}/scim-group-mappings/${mappingId}`, payload);
}

export function deleteScimGroupMapping (organizationId: number | string, mappingId: number | string) {
  return apiClient.delete<{ message: string }>(`/organizations/${organizationId}/scim-group-mappings/${mappingId}`);
}

export function generateScimKey (organizationId: number | string) {
  return apiClient.post(`/organizations/${organizationId}/scim-keys`);
}

export function deleteScimKey (organizationId: number | string, keyId: number | string) {
  return apiClient.delete(`/organizations/${organizationId}/scim-keys/${keyId}`);
}
